import PaymentGateways from './PaymentGateways';
export default PaymentGateways;
